import { css } from 'goober';

/**
 * Shared header base style
 */
const headerBase = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  background: #f8f9fa;
  color: var(--text);
  border-radius: var(--panel-radius) var(--panel-radius) 0 0;
  border-bottom: 1px solid var(--muted-border);
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.3px;
  user-select: none;
`;

/**
 * Header styles for isochrone panel
 */
export const headerIso = headerBase;

/**
 * Header styles for boundary panel
 */
export const headerBoundary = headerBase;

/**
 * Header styles for legend panel
 */
export const headerLegend = headerBase;

/**
 * Default header styles
 */
export const headerDefault = headerBase;

/**
 * Get panel-specific header class based on panel ID
 */
export function getPanelHeaderClass(_id?: string): string | undefined {
  // All panels now use the same consistent header style
  return headerBase;
}
